import { ApiProperty } from '@nestjs/swagger'

export class TableTokenResponse {
	@ApiProperty({ type: String, format: 'uuid' })
	tenantId: string

	@ApiProperty({ type: String, format: 'uuid' })
	tableId: string
}
